import { z } from 'zod'

export const QuestionnaireItemDataSchema = z.object({
  id: z.number(),
  question: z.string().nullable(),
  demographic: z
    .string()
    .nullable()
    .describe(
      '属性連携先: gender（性別）| age（年代）| area（エリア）| name（氏名）| kana（氏名かな）| none（連携なし）',
    ),
  formType: z
    .number()
    .nullable()
    .describe(
      '1:TEXT_BOX, 2:CHECK_BOX, 3:RADIOBUTTON, 4:SELECT_BOX, 5:TEXT_AREA, ' +
        '6:FILE_UPLOAD, 7:TREE（市区町村ツリー）, 8:YEAR_MONTH（年月 YYYYMM）, ' +
        '9:ZIP_CODE（郵便番号）, 10:AGE_SELECT（年齢セレクト）',
    ),
  formValue: z.array(z.string()).nullable(),
  isRequire: z.boolean().nullable(),
  isMultiple: z.boolean().nullable(),
  displayNumber: z.number().nullable(),
  deduplication: z.boolean().nullable(),
})

export const QuestionnaireDataSchema = z.object({
  id: z.number(),
  title: z.string().nullable(),
  description: z.string().nullable(),
  type: z.number().nullable().describe('1:会員登録時, 2:初回特典取得時'),
  answered: z.boolean(),
  items: z.array(QuestionnaireItemDataSchema),
})

export const QuestionnaireGetResponseSchema = z.object({
  questionnaire: QuestionnaireDataSchema.nullable(),
})

export const QuestionnaireListResponseSchema = z.object({
  questionnaires: z.array(QuestionnaireDataSchema),
})

export const QuestionnaireAnswerRequestSchema = z.object({
  questionnaireId: z.number(),
  answers: z.array(
    z.object({
      itemId: z.number(),
      answer: z.array(z.string()),
    }),
  ),
})

export type QuestionnaireItemData = z.infer<typeof QuestionnaireItemDataSchema>
export type QuestionnaireData = z.infer<typeof QuestionnaireDataSchema>
export type QuestionnaireGetResponse = z.infer<typeof QuestionnaireGetResponseSchema>
export type QuestionnaireListResponse = z.infer<typeof QuestionnaireListResponseSchema>
export type QuestionnaireAnswerRequest = z.infer<typeof QuestionnaireAnswerRequestSchema>
